import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const Login = resolve => require(["../views/Login.vue"], resolve);
const Index = resolve => require(["../views/Index.vue"], resolve);

const DeviceRomReleaseStable = resolve => require(["../pages/DeviceRomReleaseStable.vue"], resolve);
const DeviceRomReleaseBeta = resolve => require(["../pages/DeviceRomReleaseBeta.vue"], resolve);

const CreateTask = resolve => require(["../views/CreateTask.vue"], resolve);
const SecondChannel = resolve =>
  require(["../views/SecondChannel.vue"], resolve);

const TaskList = resolve => require(["../views/TaskList.vue"], resolve);
const FileList = resolve => require(["../views/FileList.vue"], resolve);
const AlarmChannel = resolve => require(["../views/AlarmChannel.vue"], resolve);

const AlarmRecord = resolve => require(["../views/AlarmRecord.vue"], resolve);
const AppAlarm = resolve => require(["../views/AppAlarm.vue"], resolve);
const AlarmConfiguration = resolve =>
  require(["../views/AlarmConfiguration.vue"], resolve);

const UserControl = resolve => require(["../views/UserControl.vue"], resolve);
const RoleControl = resolve => require(["../views/RoleControl.vue"], resolve);
const PagePermission = resolve =>
  require(["../views/PagePermission.vue"], resolve);
const Organizational = resolve =>
  require(["../views/Organizational.vue"], resolve);

const LogAudit = resolve => require(["../views/LogAudit.vue"], resolve);
const SystemSettings = resolve =>
  require(["../views/SystemSettings.vue"], resolve);

const DeviceConfig = resolve => require(["../views/DeviceConfig.vue"], resolve);
const DeviceRecord = resolve => require(["../views/DeviceRecord.vue"], resolve);
const DeviceAuthCode = resolve => require(["../views/DeviceAuthCode.vue"], resolve);
const DeviceRomAutoUpload = resolve => require(["../views/DeviceRomAutoUpload.vue"], resolve);
const DeviceRomAutoUploadAdmin = resolve => require(["../views/DeviceRomAutoUploadAdmin.vue"], resolve);
const DeviceRomDownload = resolve => require(["../views/DeviceRomDownload.vue"], resolve);
const DeviceRomStorage = resolve => require(["../views/DeviceRomStorage.vue"], resolve);
const DeviceRomCloudApi = resolve => require(["../views/DeviceRomCloudApi.vue"], resolve);
const DeviceMacUuid = resolve => require(["../views/DeviceMacUuid.vue"], resolve);
const DeviceActionInfo = resolve => require(["../views/DeviceActionInfo.vue"], resolve);
const DeviceActionFiles = resolve => require(["../views/DeviceActionFiles.vue"], resolve);
const RemoteLogDevices = resolve => require(["../views/RemoteLogDevices.vue"], resolve)
const CloudServer = resolve => require(["../views/CloudServer.vue"], resolve);
const CloudEnv = resolve => require(["../views/CloudEnv.vue"], resolve);
const DeviceMonitorMetrics = resolve => require(["../views/DeviceMonitorMetrics.vue"], resolve);
const DeviceMonitorTasks = resolve => require(["../views/DeviceMonitorTasks.vue"], resolve);
const DeviceMonitorResult = resolve => require(["../views/DeviceMonitorResult.vue"], resolve);
const DeviceMonitorTemplateItems = resolve => require(["../views/DeviceMonitorTemplateItems.vue"], resolve);
const DeviceMonitorTemplateTypes = resolve => require(["../views/DeviceMonitorTemplateTypes.vue"], resolve);
const DeviceTypes = resolve => require(["../views/DeviceTypes.vue"], resolve);
const DeviceModels = resolve => require(["../views/DeviceModels.vue"], resolve);
const DeviceSecurityAuthTool = resolve => require(["../views/DeviceSecurityAuthTool.vue"], resolve);
const SreApiUrl = resolve => require(["../views/SreApiUrl.vue"], resolve);
const SreApiDeviceOfflineTask = resolve => require(["../views/SreApiDeviceOfflineTask.vue"], resolve);
const SreApiDeviceOfflineResult = resolve => require(["../views/SreApiDeviceOfflineResult.vue"], resolve);
const SreApiDeviceCount = resolve => require(["../views/SreApiDeviceCount.vue"], resolve);
const SreApiDeviceOfflineAuthcode = resolve => require(["../views/SreApiDeviceOfflineAuthcode.vue"], resolve);
// 业务数据订阅
const Subscriber = resolve => require(["../views/Subscriber.vue"], resolve);
const SubscriberSubscribe = resolve => require(["../views/SubscriberSubscribe.vue"], resolve);
const SubscriberBusinessReportDis = resolve => require(["../views/SubscriberBusinessReportDis.vue"], resolve);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: "/login",
      name: "login",
      meta: {
        title: "AkuvoxMaintenance"
      },
      component: Login
    },
    {
      path: "/stable-firmware",
      name: "stable-firmware",
      meta: {
        title: "AkuvoxReleaseFirmware",
        requireAuth: false,
      },
      component: DeviceRomReleaseStable
    },
    {
      path: "/beta-firmware",
      name: "beta-firmware",
      meta: {
        title: "AkuvoxBetaFirmware",
        requireAuth: false,
      },
      component: DeviceRomReleaseBeta
    },
    {
      path: "/", //每次进入时加载斜杠/,将其绑到index，此时会报错，需要重定向
      name: "index",
      meta: {
        title: "AkuvoxMaintenance"
      },
      component: Index,
      redirect: "/createTask",
      children: [
        {
          path: "createTask",
          name: "createTask",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: CreateTask
        },
        {
          path: "secondChannel",
          name: "secondChannel",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SecondChannel
        },
        {
          path: "taskList",
          name: "taskList",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: TaskList
        },
        {
          path: "fileList",
          name: "fileList",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: FileList
        },
        {
          path: "alarmChannel",
          name: "alarmChannel",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: AlarmChannel
        },
        {
          path: "alarmRecord",
          name: "alarmRecord",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: AlarmRecord
        },
        {
          path: "appAlarm",
          name: "appAlarm",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: AppAlarm
        },
        {
          path: "alarmConfiguration",
          name: "alarmConfiguration",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: AlarmConfiguration
        },
        {
          path: "userControl",
          name: "userControl",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: UserControl
        },
        {
          path: "roleControl",
          name: "roleControl",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: RoleControl
        },
        {
          path: "pagePermission",
          name: "pagePermission",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: PagePermission
        },
        {
          path: "organizational",
          name: "organizational",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: Organizational
        },
        {
          path: "logAudit",
          name: "logAudit",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: LogAudit
        },
        {
          path: "systemSettings",
          name: "systemSettings",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SystemSettings
        },
        {
          path: "deviceConfig",
          name: "deviceConfig",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceConfig
        },
        {
          path: "deviceRecord",
          name: "deviceRecord",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceRecord
        },
        {
          path: "deviceAuthCode",
          name: "deviceAuthCode",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceAuthCode
        },
        {
          path: "deviceRomStorage",
          name: "deviceRomStorage",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceRomStorage
        },
        {
          path: "deviceRomCloudApi",
          name: "deviceRomCloudApi",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceRomCloudApi
        },
        {
          path: "deviceRomAutoUpload",
          name: "deviceRomAutoUpload",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceRomAutoUpload
        },
        {
          path: "deviceRomAutoUploadAdmin",
          name: "deviceRomAutoUploadAdmin",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceRomAutoUploadAdmin
        },
        {
          path: "deviceRomDownload",
          name: "deviceRomDownload",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceRomDownload
        },
        {
          path: "deviceMacUuid",
          name: "deviceMacUuid",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceMacUuid
        },
        {
          path: "deviceActionInfo",
          name: "deviceActionInfo",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceActionInfo
        },
        {
          path: "deviceActionFiles",
          name: "deviceActionFiles",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceActionFiles
        },
        {
          path: "remoteLogDevices",
          name: "remoteLogDevices",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: RemoteLogDevices
        },
        {
          path: "cloudServer",
          name: "cloudServer",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: CloudServer
        },
        {
          path: "cloudEnv",
          name: "cloudEnv",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: CloudEnv
        },
        {
          path: "deviceMonitorTasks",
          name: "deviceMonitorTasks",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceMonitorTasks
        },
        {
          path: "deviceMonitorResult",
          name: "deviceMonitorResult",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceMonitorResult
        },
        {
          path: "deviceMonitorTemplateItems",
          name: "deviceMonitorTemplateItems",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceMonitorTemplateItems
        },
        {
          path: "deviceMonitorTemplateTypes",
          name: "deviceMonitorTemplateTypes",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceMonitorTemplateTypes
        },
        {
          path: "deviceMonitorMetrics",
          name: "deviceMonitorMetrics",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceMonitorMetrics
        },
        {
          path: "deviceTypes",
          name: "deviceTypes",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceTypes
        },
        {
          path: "deviceModels",
          name: "deviceModels",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceModels
        },
        {
          path: "deviceSecurityAuthTool",
          name: "deviceSecurityAuthTool",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: DeviceSecurityAuthTool
        },
        {
          path: "sreApiUrl",
          name: "sreApiUrl",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SreApiUrl
        },
        {
          path: "sreApiDeviceOfflineTask",
          name: "sreApiDeviceOfflineTask",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SreApiDeviceOfflineTask
        },
        {
          path: "sreApiDeviceOfflineResult",
          name: "sreApiDeviceOfflineResult",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SreApiDeviceOfflineResult
        },
        {
          path: "sreApiDeviceCount",
          name: "sreApiDeviceCount",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SreApiDeviceCount
        },
        {
          path: "SreApiDeviceOfflineAuthcode",
          name: "SreApiDeviceOfflineAuthcode",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SreApiDeviceOfflineAuthcode
        },
        {
          path: "subscriber",
          name: "subscriber",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: Subscriber
        },
        {
          path: "subscriberSubscribe",
          name: "subscriberSubscribe",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SubscriberSubscribe
        },
        {
          path: "subscriberBusinessReportDis",
          name: "subscriberBusinessReportDis",
          meta: {
            title: "AkuvoxMaintenance"
          },
          component: SubscriberBusinessReportDis
        }
      ]
    }
  ]
});
